import axios from '../http'

function query(data) {
    return axios.post('/event/drawLot/query', data);
}

function get(id) {
    return axios.get('/event/drawLot/get?id=' + id);
}

function seedDraw(id) {
    return axios.get('/event/drawLot/seedDraw?id=' + id);
}

function notSeedDraw(id) {
    return axios.get('/event/drawLot/notSeedDraw?id=' + id);
}

function init(id) {
    return axios.get('/event/drawLot/init?id=' + id);
}

function seed(data) {
    return axios.post('/event/drawLot/seed', data);
}

function setSeedBoat(data) {
    return axios.post('/event/drawLot/setSeedBoat', data);
}


function cancelSeed(data) {
    return axios.post('/event/drawLot/cancelSeed', data);
}

function cancelSeedBoat(data) {
    return axios.post('/event/drawLot/cancelSeedBoat', data);
}

function editSeq(data) {
    return axios.post('/event/drawLot/editSeq', data);
}

function dynamic(data) {
    return axios.post('/event/drawLot/dynamic', data);
}

function printStartOrder(id) {
    const url = "/event/drawLot/printStartOrder?id="+id;
    return axios.get(url, { responseType: 'blob' }).then((res) => {
        const pdfUrl = window.URL.createObjectURL(new Blob([res], { type: 'application/pdf;charset=UTF-8'}));
        const newWindow = window.open(pdfUrl);
        window.URL.revokeObjectURL(newWindow);
    })
}

function exportStartOrder(id){
    const url = "/event/drawLot/exportStartOrder?id="+id;
    return axios.get(url, { responseType: 'blob' }).then((res) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(res);
        link.download = "Start List by Event.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    })
}

function draw(id) {
    return axios.get('/event/drawLot/draw?id=' + id);
}

export default {
    query,
    get,
    init,
    seedDraw,
    notSeedDraw,
    seed,
    cancelSeed,
    printStartOrder,
    exportStartOrder,
    draw,
    setSeedBoat,
    cancelSeedBoat,
    editSeq,
    dynamic
}